import { REQUIRED_ROLES } from "./rquired-roles";

export const reportsRoutes = {
  path: "/reports",
  name: "Reports",
  redirect: "/reports/buildings-efficiency",
  meta: {
    authorized: true,
    roles: REQUIRED_ROLES["initial-evaluation"],
  },
  component: () => import("@/views/reports/index.vue"),
  children: [
    {
      name: "buildingsEfficiency",
      path: "buildings-efficiency",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES["initial-evaluation"],
      },
      component: () => import("@/views/reports/buildings-efficiency/index.vue"),
    },
    {
      name: "buildingDetailedEvaluation",
      path: "building-detailed-evaluation",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES["initial-evaluation"],
      },
      component: () =>
        import("@/views/reports/building-detailed-evaluation/index.vue"),
    },
    {
      name: "capacityAndDemand",
      path: "capacity-and-demand",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES["initial-evaluation"],
      },
      component: () => import("@/views/reports/capacity-and-demand/index.vue"),
    },
    {
      name: "newCapacityAndDemand",
      path: "new-capacity-and-demand",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES["initial-evaluation"],
      },
      component: () => import("@/views/reports/new-capacity-and-demand/index.vue"),
    },
    {
      name: "CapacityReportView",
      path: "capacity-report-view",
      meta: {
        authorized: true,
        roles: REQUIRED_ROLES["initial-evaluation"],
      },
      component: () => import("@/views/reports/new-capacity-and-demand/reportView.vue"),
    },
  ],
};
